import React, { useEffect, useState, useContext, useRef } from "react";
import "@dotlottie/player-component";
import AnimatedCursor from "react-animated-cursor";
import { useNavigate } from "react-router-dom"; // 
import { isMobile } from "detect-touch-device";
/* plugin */
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, EffectFade, Navigation, Autoplay, Controller, Pagination } from "swiper/modules";
/* plugin end */
import { Link } from "react-router-dom";
import gs from "../../../service/global";
import mainContext from "../../../config/mainContext";
const { REACT_APP_ASSET_URL } = process.env;

function callWebengageTrackEvent(event_name) {
  window.webengage.track(event_name, {});
}
const faqsQus = [
  {
    question:
      "Is my money secure?",
    answer:
      "Held with Emirates NBD under DFSA client money rules.",
  },
  {
    question: "What returns can I expect?",
    answer:
      "Possible dividends + capital gains, not guaranteed.",
  },
  {
    question: "What if operations cease?",
    answer:
      "Investments remain protected in SPVs with licensed management transfer.",
  },
  {
    question: "Investment limits and fees?",
    answer: (
      <>
        <p>
          <strong>Retail Investors:</strong> Up to <strong>$100,000/year;</strong> max <strong>$50,000</strong> per property.
        </p>
        <p>
          <strong>Professional Investors:</strong> No cap (DFSA classification).
        </p>
        <p>
          <strong>Fee:</strong> 1.5% onboarding · 1% annual admin · 2.5% exit
        </p>
      </>
    )
  }
];
/* click cta event */
const gtagEvent = (label) => {
  if (window.gtag) {
    window.gtag("event", label, {
      event_category: "CTA",
      event_label: label,
    });
  }
};

function menuClick() {
  document.querySelector(".mobile-menu").classList.add("in");
  document.querySelector(".menuOverlay").classList.add("in");
  document.querySelector("body").classList.add("overflow-hidden");
}

function closeClick() {
  document.querySelector(".menuOverlay").classList.remove("in");
  document.querySelector(".mobile-menu").classList.remove("in");
  document.querySelector("body").classList.remove("overflow-hidden");
}
const features = [
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_model.svg`,
    title: "Fractionalisation Model",
    desc: "Multiple investors pool funds to participate in prime real estate.",
  },
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_svp.svg`,
    title: "SPV Ownership",
    desc: "Each property is held in a regulated Special Purpose Vehicle, ensuring investor rights.",
  },
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_protection.svg`,
    title: "Legal Protection",
    desc: "SPV structure shields investors from Slice’s business risks and liabilities.",
  },
  {
    img: `${process.env.REACT_APP_ASSET_URL}/lp/ic_transparency.svg`,
    title: "Transparency",
    desc: "Full due diligence, valuation reports, and regulated compliance under DFSA.",
  },
];

const steps = [
  {

    img: `${process.env.REACT_APP_ASSET_URL}/lp/container.svg`,
    title: "Create your account",
    desc: "Setting up a Slice account is a simple 3 step sign-up process",
  },
  {

    img: `${process.env.REACT_APP_ASSET_URL}/lp/container2.svg`,
    title: "Browse Properties",
    desc: "Discover expert-curated real estate opportunities, complete with due diligence reports, amenities, projected returns, and transparent fee details.",
  },
  {

    img: `${process.env.REACT_APP_ASSET_URL}/lp/container3.svg`,
    title: "Invest and earn returns",
    desc: "Choose your property, invest securely, and let your money work for you. Track dividends and potential appreciation directly from your Slice dashboard.",
  }
];

const LPv2 = () => {
  const [firstClientSwiper, setFirstClientSwiper] = useState(null);
  const [secondClientSwiper, setSecondClientSwiper] = useState(null);
  const navigate = useNavigate();
  const mainObj = useContext(mainContext);
  const [activeId, setActiveId] = useState("");
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  });
  const [popuperrors, setErrorsPopup] = useState({
    firstNamePopup: "",
    lastNamePopup: "",
    emailPopup: "",
    mobilePopup: "",
  });
  const validateForm = () => {
    let valid = true;
    let newErrors = { firstName: "", lastName: "", email: "", mobile: "" };

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      valid = false;
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
      valid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
      valid = false;
    }
    if (formData.mobile.trim()) {
      if (!/^[0-9]+$/.test(formData.mobile)) {
        newErrors.mobile = "Only digits are allowed";
        valid = false;
      }
    }
    setErrors(newErrors);
    return valid;
  };
  const validateFormPopup = () => {
    let valid = true;
    let newErrors = { firstNamePopup: "", lastNamePopup: "", emailPopup: "", mobilePopup: "" };

    if (!formDataPopup.firstNamePopup.trim()) {
      newErrors.firstNamePopup = "First name is required";
      valid = false;
    }

    if (!formDataPopup.lastNamePopup.trim()) {
      newErrors.lastNamePopup = "Last name is required";
      valid = false;
    }

    if (!formDataPopup.emailPopup.trim()) {
      newErrors.emailPopup = "Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formDataPopup.emailPopup)) {
      newErrors.emailPopup = "Email is invalid";
      valid = false;
    }
    if (formDataPopup.mobilePopup.trim()) {
      if (!/^[0-9]+$/.test(formDataPopup.mobilePopup)) {
        newErrors.mobilePopup = "Only digits are allowed";
        valid = false;
      }
    }
    setErrorsPopup(newErrors);
    return valid;
  };
  useEffect(() => {

    /* Loader Starts */
    gs.showLoader(true);
    /* Loader Ends */

    // Hotjar Tracking Code
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 6527090, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");


    const sections = document.querySelectorAll("section[id]");
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries.filter((e) => e.isIntersecting);
        if (visibleEntries.length > 0) {
          const mostVisible = visibleEntries.reduce((a, b) =>
            a.intersectionRatio > b.intersectionRatio ? a : b
          );
          setActiveId(mostVisible.target.id);
        }
      },
      { threshold: [0.5, 0.75, 1] }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);
  /* slider code */
  const handleSlideChange = (swiper) => {
    // console.log(swiper.activeIndex);
    const gridList = document.querySelectorAll(".comm-slide-list li");
    gridList.forEach((para) => para.classList.remove("active"));
    document.querySelector(`.st-${swiper.activeIndex}`).classList.add("active");
  };
  // Smooth scroll with header offset
  const handleScroll = (e, id) => {
    e.preventDefault();
    const target = document.getElementById(id);
    const headerOffset = 80; // adjust to your header height
    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  const handleLinkClick = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  };
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
  });

  const [formDataPopup, setFormDataPopup] = useState({
    firstNamePopup: "",
    lastNamePopup: "",
    emailPopup: "",
    mobilePopup: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChangePopup = (e) => {
    const { name, value } = e.target;
    setFormDataPopup({ ...formDataPopup, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop if form is invalid

    if (window.webengage) {
      window.webengage.onReady(() => {
        window.webengage.user.login(formData.email);
        window.webengage.user.setAttribute({
          we_first_name: formData.firstName,
          we_last_name: formData.lastName,
          we_email: formData.email,
          we_phone: formData.mobile,
        });
        window.webengage.track("LP Form Submitted", {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phone: formData.mobile,
        });
      });
    }

    setFormData({ firstName: "", lastName: "", email: "" });
    setErrors({ firstName: "", lastName: "", email: "" });

    navigate("/campaign/dubai-properties-v2/thankyou", { state: { formData } });
  };

  const handleSubmitPopup = (e) => {
    e.preventDefault();
    if (!validateFormPopup()) return;

    if (window.webengage) {
      window.webengage.onReady(() => {
        window.webengage.user.login(formDataPopup.emailPopup);
        window.webengage.user.setAttribute({
          we_first_name: formDataPopup.firstNamePopup,
          we_last_name: formDataPopup.lastNamePopup,
          we_email: formDataPopup.emailPopup,
          we_phone: formDataPopup.mobilePopup,
        });
        window.webengage.track("LP Popup Form Submitted", {
          firstName: formDataPopup.firstNamePopup,
          lastName: formDataPopup.lastNamePopup,
          email: formDataPopup.emailPopup,
          phone: formDataPopup.mobilePopup,
        });
      });
    }

    // ✅ Trigger automatic PDF download
    const pdfUrl = `${process.env.PUBLIC_URL}/assets/pdf/Slice_onepager_2.pdf`;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Slice_onepager_2.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // ✅ Reset form
    setFormDataPopup({ firstNamePopup: "", lastNamePopup: "", emailPopup: "", mobilePopup: "" });
    setErrorsPopup({ firstNamePopup: "", lastNamePopup: "", emailPopup: "", mobilePopup: "" });

    // ✅ Navigate after a short delay
    setTimeout(() => {
      navigate("/campaign/dubai-properties-v2/pop-up-thankyou", { state: { formDataPopup } });
    }, 800);
  };


  const swiperRef = useRef(null);
  const handleButtonClick = (slideIndex) => {

    if (swiperRef.current) {
      swiperRef.current?.swiper.slideTo(slideIndex);
    }
  };
  const [activeIndex, setActiveIndex] = useState(0); // first open

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  //popu
  const [showPopup1, setShowPopup1] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);

  useEffect(() => {
    // Show first popup automatically after 90 seconds (90000 ms)
    const timer = setTimeout(() => {
      setShowPopup1(true);
    }, 60000);

    return () => clearTimeout(timer);
  }, []);

  const handleYesClick = () => {
    gtagEvent("V1Popup_Accept");
    setShowPopup1(false); // close first popup
    setShowPopup2(true);  // open second popup
  };

  const handleClose = () => {
    gtagEvent("V1Popup_Reject");
    setShowPopup1(false);
    setShowPopup2(false);
  };
  const promiseCircle = useRef(null);
  const promiseWrap = useRef(null);
  /* The Slice Promise  starts */
  if (window.innerWidth > 990) {
    var i = 1;
    var hovering = false;

    function doSetTimeout() {
      if (hovering === false) {
        setTimeout(() => {
          if (i > 5) {
            i = 1;
            rotateCirc["rotateCirc" + i]();
          } else {
            rotateCirc["rotateCirc" + i]();
          }
          setTimeout(() => {
            doSetTimeout();
          }, 800);
        }, i * 500);
        i++;
      }
    }

    doSetTimeout();

    var promiseNumbers = document.querySelectorAll(".promise-numbers");

    function handleMouseOver(e) {
      hovering = true;
      var x = e.currentTarget.getAttribute("data-id");
      rotateCirc["rotateCirc" + x]();
    }

    for (var j = 0; j < promiseNumbers.length; j++) {
      promiseNumbers[j].addEventListener("mouseover", handleMouseOver);
    }

    var rotateCirc = {
      rotateCirc1: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(0deg)";
          promiseWrap.current.style.background = "rgba(46,255,215,0.15)";
        }
      },

      rotateCirc2: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(72deg)";
          promiseWrap.current.style.background = "rgb(86 253 46 / 40%)";
        }
      },

      rotateCirc3: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(144deg)";
          promiseWrap.current.style.background = "rgb(67 37 245 / 40%)";
        }
      },

      rotateCirc4: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(216deg)";
          promiseWrap.current.style.background = "rgb(255 191 23 / 40%)";
        }
      },

      rotateCirc5: function () {
        if (promiseCircle.current && promiseWrap.current) {
          promiseCircle.current.style.transform = "rotate(288deg)";
          promiseWrap.current.style.background = "rgb(235 112 50 / 40%)";
        }
      },
    };
  }
  useEffect(() => {
    // scroll to #hash on load
    const hash = window.location.hash;
    if (hash) {
      const targetElement = document.getElementById(hash.substring(1));
      if (targetElement) {
        setTimeout(() => {
          const headerOffset =
            document.querySelector("header")?.offsetHeight || 80;
          const elementPosition =
            targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }, 500);
      }
    }
  }, []);
  return (
    <>
      <header id="header" className="sticky">

        <div className="header-box">

          <div className="head-left">


            <div className="logoBox">
              {/* <Link className="logo" href="/" onClick={() => window.scrollTo(0, 0)}>
                                  
                                      <img src={`${REACT_APP_ASSET_URL}/logo.svg`} alt="Logo" />
                                  </Link> */}
              <a href="#Home" onClick={(e) => {
                e.preventDefault();
                callWebengageTrackEvent("Home SLICE Tab clicked");
                handleScroll(e, "Home");
              }}
                className={activeId === "Home" ? "active logo" : "logo"} >     <img src={`${REACT_APP_ASSET_URL}/logo.svg`} alt="Logo" />
              </a>
            </div>
            <div className="startInvesbut headbut">
              <Link href="/" className="curzr-hover change-cursor" onClick={(e) => {
                e.preventDefault();
                callWebengageTrackEvent("fractiOwners SLICE Tab clicked");
                gtagEvent("L1Get_Started_Header");
                handleScroll(e, "fractiOwners");
              }}>
                Get Started
              </Link>
            </div>
          </div>
          <div className="menu side-menu" onClick={menuClick}>
            <img src={`${REACT_APP_ASSET_URL}/lp/menu-burger.svg`} alt="mobile-menu" />

          </div>
          <ul className="header-list headerCur">

            <li>
              <a
                href="#AboutSLICE"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("About SLICE Tab clicked");
                  handleScroll(e, "AboutSLICE");
                }}
                className={activeId === "AboutSLICE" ? "active" : ""}
              >        About SLICE
              </a>
            </li>
            <li>
              <a
                href="#WhyInvesthere"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Why Invest here? Tab Clicked");
                  handleScroll(e, "WhyInvesthere");
                }}
                className={activeId === "WhyInvesthere" ? "active" : ""}
              >
                Why Invest here?
              </a>
            </li>
            <li>
              <a
                href="#Howitworks"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("How it Works Tab clicked");
                  handleScroll(e, "Howitworks");
                }}
                className={activeId === "Howitworks" ? "active" : ""}
              >
                How it works
              </a>
            </li>
            <li>
              <a
                href="#Returns"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Returns Tab clicked");
                  handleScroll(e, "Returns");
                }}
                className={activeId === "Returns" ? "active" : ""}
              >
                Returns & Security
              </a>
            </li>

            <li>
              <a
                href="#Faqs"
                onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Faqs Tab clicked");
                  handleScroll(e, "Faqs");
                }}
                className={activeId === "Faqs" ? "active" : ""}
              >
                FAQ’s
              </a>
            </li>
            <li className="startInvesbut ">
              <Link href="/" onClick={(e) => {
                e.preventDefault();
                callWebengageTrackEvent("Home SLICE Tab clicked");
                gtagEvent("L1Get_Started_Header");
                handleScroll(e, "Home");
              }} className="curzr-hover change-cursor">
                Get Started
              </Link>
            </li>

          </ul>

        </div>
        {/* Side Menu */}
        <div className="menuOverlay" />
        <div className="mobile-menu">
          <h3 className="close-menu" onClick={closeClick}>
            <img src={`${REACT_APP_ASSET_URL}/common/cross.svg`} alt="cancel" />
          </h3>
          <ul className="header-list">
            <li>
              <a
                href="#AboutSLICE"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("About SLICE Tab clicked");
                  handleScroll(e, "AboutSLICE");
                }}
                className={activeId === "AboutSLICE" ? "active" : ""}
              >
                About SLICE
              </a>
            </li>
            <li>
              <a
                href="#WhyInvesthere"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Why Invest here? Tab Clicked");
                  handleScroll(e, "WhyInvesthere");
                }}
                className={activeId === "WhyInvesthere" ? "active" : ""}
              >
                Why Invest here?
              </a>
            </li>
            <li>
              <a
                href="#Howitworks"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("How it Works Tab clicked");
                  handleScroll(e, "Howitworks");
                }}
                className={activeId === "Howitworks" ? "active" : ""}
              >
                How it works
              </a>
            </li>
            <li>
              <a
                href="#Returns"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Returns Tab clicked");
                  handleScroll(e, "Returns");
                }}
                className={activeId === "Returns" ? "active" : ""}
              >
                Returns & Security
              </a>
            </li>

            <li>
              <a
                href="#SlicePromise"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Slice Promise Tab clicked");
                  handleScroll(e, "SlicePromise");
                }}
                className={activeId === "SlicePromise" ? "active" : ""}
              >
                Slice Promise
              </a>
            </li>

            <li>
              <a
                href="#Testimonials"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Testimonials Tab clicked");
                  handleScroll(e, "Testimonials");
                }}
                className={activeId === "Testimonials" ? "active" : ""}
              >
                Testimonials
              </a>
            </li>

            <li>
              <a
                href="#Faqs"
                onClick={(e) => {
                  e.preventDefault();
                  closeClick();
                  callWebengageTrackEvent("Faqs Tab clicked");
                  handleScroll(e, "Faqs");
                }}
                className={activeId === "Faqs" ? "active" : ""}
              >
                FAQ’s
              </a>
            </li>


          </ul>
        </div>



      </header>

      <main className="cursorNo">
        <section id="Home" className="abouSli abouSlV1v2">

          <div className="container">
            <div className="f-row f-3 f-990-1 change-cursor">
              <div className="f-col w50">
                <h1 className="fs-1"><strong> In minutes, not months-</strong> own your share of <strong>Dubai real estate.</strong>
                </h1>
                <p className="fs-4 mbNon"><strong>Frictionless, transparent,</strong> and <strong>fully regulated </strong> access to premium curated properties in Dubai. <strong>Fractional ownership starting from as low as $100</strong>-affordable, secure, and built for the future of investing.</p>
                <div className="get-slice-btns banner-slice-btns">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.slice.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      gtagEvent("V2Google_App");
                      setTimeout(() => {
                        window.open("https://play.google.com/store/apps/details?id=com.slice.com", "_blank");
                      }, 150);
                    }}
                  >
                    <img src={`${REACT_APP_ASSET_URL}/common/slice-google-play.svg`} alt="Slice Google Play" />
                  </a>

                  <a href="https://apps.apple.com/us/app/slice-real-estate-super-app/id6446883858" target="_blank" className="curzr-hover" rel="noopener noreferrer" onClick={(e) => {
                    e.preventDefault();
                    gtagEvent("V2Apple_App");
                    setTimeout(() => {
                      window.open("https://apps.apple.com/us/app/slice-real-estate-super-app/id6446883858", "_blank");
                    }, 150);
                  }}>
                    <img
                      src={`${REACT_APP_ASSET_URL}/common/slice-app-store.svg`}
                      alt="Slice App Store"
                    />
                  </a>
                </div>
              </div>
              <div className="f-col cardText d-none">

                <div className="card">


                  <ul className="d-flex gap-3 startRegul">
                    <li>
                      <img src={`${REACT_APP_ASSET_URL}/lp/start-as-low.svg`} alt="Start as low as $100" />
                      <h4 className="fs-7">Start as low <br /> as $100</h4>
                    </li>
                    <li>
                      <img src={`${REACT_APP_ASSET_URL}/lp/regulated.svg`} alt="DFSA Regulated" />
                      <h4 className="fs-7">DFSA <br /> Regulated</h4>
                    </li>
                    <li>
                      <img src={`${REACT_APP_ASSET_URL}/lp/managed.svg`} alt="Fully Managed" />
                      <h4 className="fs-7">Fully <br /> Managed</h4>
                    </li>
                  </ul>
                </div>



              </div>
              <div id="fractiOwners" className="f-col cardform">
                <div className="card">
                  <h2 className="fs-4 mb-2">
                    <span className="dexTex">Fractional ownership starting from as low as $100</span>
                    <span className="mobiTex">Start your journey now!</span>
                  </h2>

                  <form onSubmit={handleSubmit} className="formBox">
                    <div className="mb-4">
                      <label>First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                        className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                      />
                      {errors.firstName && <p className="text-red-500 text-sm">{errors.firstName}</p>}
                    </div>

                    <div className="mb-4">
                      <label>Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                        className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                      />
                      {errors.lastName && <p className="text-red-500 text-sm">{errors.lastName}</p>}
                    </div>

                    <div className="mb-4">
                      <label>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleChange}
                        className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                      />
                      {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                    </div>

                    <div className="mb-4">
                      <label>Mobile</label>
                      <input
                        type="text"
                        name="mobile"
                        placeholder="Mobile Number (optional)"
                        value={formData.mobile}
                        onChange={handleChange}
                        className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                      />
                      {errors.mobile && <p className="text-red-500 text-sm">{errors.mobile}</p>}
                    </div>
                    <button type="submit" className="startToday" >
                      Get Started
                    </button>
                  </form>

                </div>
              </div>
              <div className="get-slice-btns banner-slice-btns mob">
                <a href="https://play.google.com/store/apps/details?id=com.slice.com" target="_blank" className="curzr-hover " rel="noopener noreferrer" onClick={(e) => {
                  gtagEvent("V1Google_App");
                }}>
                  <img
                    src={`${REACT_APP_ASSET_URL}/common/slice-google-play.svg`}
                    alt="Slice Google Play"
                  />
                </a>
                <a href="https://apps.apple.com/us/app/slice-real-estate-super-app/id6446883858" target="_blank" className="curzr-hover" rel="noopener noreferrer" onClick={(e) => {
                  gtagEvent("V1Apple_App");
                }}>
                  <img
                    src={`${REACT_APP_ASSET_URL}/common/slice-app-store.svg`}
                    alt="Slice App Store"
                  />
                </a>
              </div>
            </div>

          </div>
        </section>

        <section id="AboutSLICE" className="get-slice-box py sliceMak">

          <div className="container">
            <div className="f-row f-2 f-990-1 change-cursor">
              <div className="f-col pe-4">
                <h3 className="fs-1 white">
                  Slice makes real <br />
                  estate investing possible through fractionalisation —
                </h3>
                <p className="fs-4 white">
                  Where investors pool funds to collectively own a property via a Special Purpose Vehicle (SPV). This structure provides legal protection, transparency, and access to opportunities that would otherwise be out of reach for individual investors.
                </p>
              </div>

              <div className="f-col">
                <div className="desktopSlider f-row f-2 f-990-1 change-cursor">
                  {features.map((feature, index) => (
                    <div key={index} className="f-col mb-2">
                      <div className="border-1">
                        <div className="d-flex gap-3 mb-2">
                          <img src={feature.img} alt={feature.title} />
                          <h4 className="fs-3">{feature.title}</h4>
                        </div>
                        <p className="fs-5 white">{feature.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Mobile Slider */}
                <div className="mobileSlider">
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={16}
                    slidesPerView={1}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    loop={true}
                    pagination={{
                      clickable: true,
                      el: '.slider__pagination' // reference custom pagination container
                    }}

                  >
                    {features.map((feature, index) => (
                      <SwiperSlide key={index}>
                        <div className="border-1 p-3">
                          <div className="d-flex gap-3 mb-2">
                            <img src={feature.img} alt={feature.title} />
                            <h4 className="fs-3">{feature.title}</h4>
                          </div>
                          <p className="fs-5 white">{feature.desc}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  {/* Pagination and buttons outside Swiper */}
                  <div className="slider__controls">
                    <div className="slider__pagination"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whatPlatf pb-0">
          <div className="container">
            <div className="f-row ">
              <div className="f-col ">
                <div className="whatBox">
                  <h2 className="fs-2">What is This Platform?</h2>
                  <p className="fs-4"><strong>A frictionless, transparent, and safe platform </strong> that fractionalizes real estate investment.</p>
                  <p className="fs-4">Breaking barriers with affordable entry, curated prime properties, and fully managed structures—so you focus on growth, not complexity.</p>
                  <p className="fs-3"> <img src={`${REACT_APP_ASSET_URL}/lp/ic_arrow2.svg`} alt="people" /> The future of investing-fractional, flexible, and fully managed. <img src={`${REACT_APP_ASSET_URL}/lp/ic_arrow.svg`} alt="people" /></p>
                </div> </div>
            </div>
          </div>
        </section>
        <section id="WhyInvesthere" className="whatPlatf">
          <div className="container">

            <div className="f-row f-1 illusProp">

              <div className="hiw-illus-prop-cube-5">
                <img src={`${REACT_APP_ASSET_URL}/lp/prop.svg`} alt="star" className="mb-2" />
              </div>
              <div className="f-col text-center mb-4">
                <h2 className="fs-2">Why Invest Here?</h2>
                <p className="fs-4 mb-4">A Regulated Gateway to Global Opportunities</p>
              </div>

            </div>


            <div className="f-row f-3 whatPlBx f-990-1 change-cursor">

              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest.svg`} alt="Start Small" className="mb-2" />
                  <h3 className="fs-3">Start Small</h3>
                  <p className="fs-7">Invest in affordable fractional units, beginning from just $100.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest2.svg`} alt="Regulated & Safe" className="mb-2" />
                  <h3 className="fs-3">Regulated & Safe</h3>
                  <p className="fs-7">Licensed under DFSA, based in DIFC.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest3.svg`} alt="Income Potential" className="mb-2" />
                  <h3 className="fs-3">Income Potential</h3>
                  <p className="fs-7">Earn dividends from rental income with potential property appreciation.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest4.svg`} alt="Funds Custody" className="mb-2" />
                  <h3 className="fs-3">Funds Custody</h3>
                  <p className="fs-7">Held securely with Emirates NBD in segregated accounts.</p>
                </div>

              </div>
              <div className="f-col mb-4">
                <div className="card">
                  <img src={`${REACT_APP_ASSET_URL}/lp/ic_invest5.svg`} alt="Easy Entry & Exit" className="mb-2" />
                  <h3 className="fs-3">Easy Entry & Exit</h3>
                  <p className="fs-7">Get access to our marketplace so you can start with small investment amounts and expand over time, with the flexibility to adapt your investments as your goals evolve.</p>
                </div>

              </div>

            </div>
            <div className="f-row f-1">

              <div className="f-col mb-4 text-center">
                <Link href="/" onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Home SLICE Tab clicked");
                  handleScroll(e, "fractiOwners");
                  gtagEvent("L1Start_Investing_Today");
                }} className="butSta btn1">Start Investing Today  </Link>

              </div>

            </div>
          </div>
        </section>

        <section id="Howitworks" className="comm-section">
          <div className="hiw-illus-prop-cube-5">
            <img src={`${REACT_APP_ASSET_URL}/lp/prop1.svg`} alt="star" className="mb-2" />
          </div>
          <div className="hiw-illus-prop-cube-4">
            <img src={`${REACT_APP_ASSET_URL}/lp/ic_star.png`} alt="star" className="mb-2" />
          </div>
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2 mb-2">How It Works</h3>
              <h4 className="fs-8">Investing Made Simple</h4>
            </div>
            <div className="process-wrap">

              <div className="process-right">
                <Swiper
                  ref={swiperRef}
                  slidesPerView={1}
                  speed={800}
                  effect={"fade"}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  modules={[EffectFade, Autoplay]}
                  className="swiper swiperPro swiper-process"
                  onSlideChange={(swiper) => handleSlideChange(swiper)}
                >
                  <SwiperSlide className="swiper-slide">
                    <div className="solutions-media">
                      <img src={`${REACT_APP_ASSET_URL}/lp/mobile.png`} alt="Easy Entry & Exit" className="mb-2" />


                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="solutions-media">
                      <img src={`${REACT_APP_ASSET_URL}/lp/mobile2.png`} alt="Easy Entry & Exit" className="mb-2" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <div className="solutions-media">
                      <img src={`${REACT_APP_ASSET_URL}/lp/mobile3.png`} alt="Easy Entry & Exit" className="mb-2" />
                    </div>
                  </SwiperSlide>



                </Swiper>
              </div>
              <div className="process-left">
                {/* Desktop list */}
                <ul className="solutions-left-wrap comm-slide-list desktopSlider">
                  {steps.map((step, index) => (
                    <li
                      key={index}
                      className={`sol-text st-${index}`}
                      onClick={() => handleButtonClick(index)}
                    >
                      <div className="d-flex d-row gap-3">
                        <img src={step.img} alt={step.title} />
                        <div className="txt-wrap-sol">
                          <h4>{step.title}</h4>
                          <p>{step.desc}</p>
                        </div>
                      </div>
                      <div className="complete-line" />
                    </li>
                  ))}
                </ul>

                {/* Mobile Swiper slider */}
                <div className="mobileSlider">
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={16}
                    slidesPerView={1}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    loop={true}
                    pagination={{
                      clickable: true,
                      el: '.slider_pagination' // reference custom pagination container
                    }}

                  >
                    {steps.map((step, index) => (
                      <SwiperSlide key={index}>
                        <li
                          className={`sol-text st-${index}`}
                          onClick={() => handleButtonClick(index)}
                          style={{ listStyle: "none" }}
                        >
                          <div className="d-flex d-row gap-3">
                            <img src={step.img} alt={step.title} />
                            <div className="txt-wrap-sol">
                              <h4>{step.title}</h4>
                              <p>{step.desc}</p>
                            </div>
                          </div>
                        </li>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="slider__controls">
                    <div className="slider_pagination"></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

        <section id="Returns" className="returSecu">
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2 mb-4">Returns & Security</h3>
              <h4 className="fs-8">Transparent Structures. Potential Returns. Built-in Safeguards.</h4>
            </div>
            <div className="f-row f-2 f-990-1 change-cursor mt-5 returCont">
              <div className="f-col mb-4"> <div className="card internalBanner">
                <h4 className="fs-3">Earnings</h4>
                <ul>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Dividends</h4>
                      <p className="fs-7">From rental income, paid as per agreements.</p>
                    </div>


                  </li>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning1.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Capital Appreciation</h4>
                      <p className="fs-7">Possible gains from value growth.</p>
                    </div>
                  </li>

                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning2.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Valuation Transparency</h4>
                      <p className="fs-7">Independent valuations via dashboard.</p>
                    </div>


                  </li>

                </ul>


              </div>
              </div>
              <div className="f-col mb-4"> <div className="card missionColoured">
                <h4 className="fs-3">Retail Investors</h4>
                <ul>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning3.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">SPV Structure</h4>
                      <p className="fs-7">Each property is ring-fenced.</p>
                    </div>


                  </li>
                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning4.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Funds Safety</h4>
                      <p className="fs-7">Segregated accounts with Emirates NBD.</p>
                    </div>
                  </li>

                  <li className="d-flex gap-3">
                    <img src={`${REACT_APP_ASSET_URL}/lp/earning5.svg`} alt="Invest and earn returns" />
                    <div className="">
                      <h4 className="fs-7">Data Protection</h4>
                      <p className="fs-7">Encrypted, with no third-party data sales.</p>
                    </div>


                  </li>

                </ul>


              </div>
              </div>

            </div>
            <div className="commBot">

              <p> <strong> Disclaimer:</strong> Returns not guaranteed. Past performance is not indicative of future results.</p>
            </div>

          </div>
        </section>
        {/* Real Deal Of Real Estate START */}
        <section className="comm-section">
          <div className="container">
            <div className="comm-center-head">
              <h2 className="comm-head-2">Real Deal Of Real Estate </h2>
            </div>
            <div className="section-body table-responsive responPpc">
              <div className="table-wrap active">
                <div className="table-row table-row-1">
                  <div className="table-col table-col-1">
                    <div className="asset-box">
                      <h3 className="comm-head-5">Asset Class</h3>
                      <p className="comm-head-6">
                        Average Annual Return <br />
                        <span className="grey">Based on 20 year CAGR</span>
                      </p>
                    </div>
                  </div>
                  <div className="table-col table-col-2">
                    <div className="table-head">
                      <p className="table-title">Stocks</p>
                      <h2 className="table-data">8.91%</h2>
                    </div>
                    <div className="table-head">
                      <p className="table-title">Bonds</p>
                      <h2 className="table-data">6.02%</h2>
                    </div>
                    <div className="table-head">
                      <p className="table-title">Gold</p>
                      <h2 className="table-data">9.65%</h2>
                    </div>
                  </div>
                </div>
                <div className="table-row table-row-2">
                  <div className="table-col table-col-3">
                    <div className="re-box">
                      <ul className="asset-list">
                        <li>
                          <span className="comm-head-6">Regular cashflow</span>
                        </li>
                        <li>
                          <span className="comm-head-6">
                            Capital Appreciation
                          </span>
                        </li>
                        <li>
                          <span className="comm-head-6">Low Volatility</span>
                        </li>
                        <li>
                          <span className="comm-head-6">Inflation Hedge</span>
                        </li>
                        <li>
                          <span className="comm-head-6">Recession Hedge</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-col table-col-4">
                    <div className="table-body-wrap">
                      <div className="table-body">
                        <ul className="asset-list">
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon text high">High</span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="table-body">
                        <ul className="asset-list">
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon text">Medium</span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="table-body">
                        <ul className="asset-list">
                          <li>
                            <span className="icon cross">
                              <span className="icon-cross" />
                            </span>
                          </li>
                          <li>
                            <span className="icon text">Medium</span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                          <li>
                            <span className="icon tick">
                              <span className="icon-tick" />
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-row table-row-3">
                  <div className="table-col table-col-5">
                    <div className="table-head">
                      <p className="table-title">Real Estate</p>
                      <h2 className="table-data">11.72%</h2>
                    </div>
                    <div className="table-body">
                      <ul className="asset-list">
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                        <li>
                          <span className="icon text high">High</span>
                        </li>
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                        <li>
                          <span className="icon tick">
                            <span className="icon-tick" />
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="f-col text-center">
              <Link href="/" onClick={(e) => {
                e.preventDefault();
                callWebengageTrackEvent("Home SLICE Tab clicked");
                handleScroll(e, "fractiOwners");
                gtagEvent("L1Get_Started_middle");
              }} className="butSta" >Get Started</Link>


            </div>
          </div>
        </section>
        {/* Real Deal Of Real Estate END */}

        {/* The Slice Promise */}
        <section className="comm-section promise-sec" id="SlicePromise">
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2">The Slice Promise</h3>
            </div>
            <div className="promise-wrap" ref={promiseWrap}>
              <div className="promise-circle" ref={promiseCircle}>
                <img src={`${REACT_APP_ASSET_URL}/about/circle.png`} alt="" />
              </div>
              <div className="promise-numbers promise-numbers-1" data-id={1}>
                1
                <div className="tooltip">
                  <p>Democratize Real Estate</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-2" data-id={2}>
                2
                <div className="tooltip">
                  <p>Help achieve Real Estate Aspiration for Millions of Users Globally</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-3" data-id={3}>
                3
                <div className="tooltip">
                  <p>Provide simple &amp; transparent transaction</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-4" data-id={4}>
                4
                <div className="tooltip">
                  <p>Deliver best in class ROI</p>
                </div>
              </div>
              <div className="promise-numbers promise-numbers-5" data-id={5}>
                5
                <div className="tooltip">
                  <p>User experience &amp; user service obsessed</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* The Slice Promise */}

        {/* Happy To SLICE START */}
        <section id="Testimonials" className="comm-section client-section">
          <div className="container">
            <div className="f-row">
              <div className=" w-1200-40 w-990-100">
                <div className="section-header client-header">
                  <h2 className="comm-head-2">Happy To Slice</h2>
                  <p className="comm-body-large">
                    Customers are happily investing with Slice
                  </p>
                </div>
              </div>
              <div className="w70 w-1200-60 w-990-100">
                <Swiper
                  className="client-swiper clientSwiper"
                  effect="coverflow"
                  slidesPerView={1}
                  spaceBetween={0}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  speed={1500}
                  coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    // depth: 450,
                    depth: 200,
                    modifier: 2,
                    slideShadows: false,
                  }}
                  keyboard={{
                    enabled: true,
                  }}
                  breakpoints={{
                    390: { slidesPerView: 1 },
                    480: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    1200: { slidesPerView: 2.7 },
                    1280: { slidesPerView: 3 },
                  }}
                  modules={[Navigation, EffectCoverflow, Autoplay, Controller]}
                  navigation={{
                    prevEl: ".clientSwiperPrev",
                    nextEl: ".clientSwiperNext",
                    clickable: true,
                  }}
                  onSwiper={setFirstClientSwiper}
                  controller={{ control: secondClientSwiper }}>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t2-brooke-anderson_BNK63KLO.jpg`}
                            alt="Brooke Anderson"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t8-vishal-saini_HkzJM6ml.jpg`}
                            alt="Vishal Saini"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t5-james-henderson_ptOiR6mv.jpg`}
                            alt="James Henderson"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t6-rizwan-riaz_fZufQQWa.jpg`}
                            alt="Rizwan Riaz"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t7-stuart-branson_hopo6y8z.jpg`}
                            alt="Stuart Branson"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t10-hal-luscombe_j0r20OcX.jpg`}
                            alt="Hal Luscombe"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t3-camelia-olteanu_CTr7pCSg.jpg`}
                            alt="Camelia Olteanu"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t1-alex-popovici_kvMFtBKU.jpg`}
                            alt="Alex Popovici"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t4-clifford-de-souza_a2RKirVN.jpg`}
                            alt="Clifford de Souza"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-wrap founder-wrap">
                      <div className="founder-box-wrap">
                        <div className="founder-box">
                          <img
                            src={`${REACT_APP_ASSET_URL}/index/t9-zaw-min-htun-1_2EBpQGLK.jpg`}
                            alt="Zaw Min Htun"
                            width="100%"
                            height="100%"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>

                <Swiper
                  spaceBetween={25}
                  slidesPerView={1}
                  centeredSlides={true}
                  loop={true}
                  // autoplay={{
                  //   delay: 2000,
                  //   disableOnInteraction: false,
                  // }}
                  className="client-text-swiper clientTextSwiper"
                  breakpoints={{
                    390: { slidesPerView: 1 },
                    480: {
                      slidesPerView: 1,
                    },
                    640: { slidesPerView: 2 },
                    1200: { slidesPerView: 2.7 },
                    1280: { slidesPerView: 3 },
                  }}
                  modules={[Autoplay, Controller]}
                  effect="fade"
                  onSwiper={setSecondClientSwiper}
                  controller={{ control: firstClientSwiper }}>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice real estate app in Dubai is a shining example of
                        transparency and seamlessness. It provides a clear window
                        into the real estate market and offers an incredibly
                        smooth user experience. Investing has never been this
                        straightforward, and I couldn't be happier with Slice!
                      </p>
                      <h2 className="comm-head-5 mb5">Brooke Anderson</h2>
                      <p className="comm-country">New Zealand</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        Slice is a fantastic way to invest in real estate. The app
                        is incredibly easy to use with a very neat and
                        user-friendly interface that makes it simple to find and
                        invest in properties that suit my needs.
                      </p>
                      <h2 className="comm-head-5 mb5">Vishal Saini</h2>
                      <p className="comm-country">India</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        I'm absolutely thrilled with Slice – it's a phenomenal
                        avenue for real estate investment. The app's sheer
                        simplicity, coupled with its impeccably organized and
                        user- friendly interface, effortlessly guides me to
                        discover and invest in properties that perfectly align
                        with my requirements. It's an outstanding experience!
                      </p>
                      <h2 className="comm-head-5 mb5">James Henderson</h2>
                      <p className="comm-country">Republic of South Africa</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        Slice App is perfectly designed keeping all kinds of
                        investors in mind. The concise information and ease of use
                        really make the investment process smooth.
                      </p>
                      <h2 className="comm-head-5 mb5">Rizwan Riaz</h2>
                      <p className="comm-country">Dubai</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        I am thrilled with the Slice real estate app! Its
                        user-friendly interface makes real estate investment a
                        breeze. I can easily choose and invest in property slices,
                        and I'm excited to watch my portfolio grow with Slice.
                        It's a game-changer!
                      </p>
                      <h2 className="comm-head-5 mb5">Stuart Branson</h2>
                      <p className="comm-country">United Kingdom</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice real estate app is the epitome of a
                        frictionless, cool, and seamless experience. It simplifies
                        the complex world of real estate investing and offers an
                        effortless journey from start to finish. If you want an
                        app that combines style with substance, look no further –
                        Slice has it all!
                      </p>
                      <h2 className="comm-head-5 mb5">Hal Luscombe</h2>
                      <p className="comm-country">Republic of South Africa</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice app in Dubai is a real estate revolution. It's
                        thrilling, user-friendly, and effortlessly simplifies
                        property investment in Dubai. Navigating the market is now
                        a breeze, thanks to its unique blend of simplicity and
                        excitement.
                      </p>
                      <h2 className="comm-head-5 mb5">Camelia Olteanu</h2>
                      <p className="comm-country">Luxembourg</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice app has revolutionized my real estate
                        investments. It's incredibly user-friendly, making the
                        entire process seamless. With a few clicks, I explore
                        diverse properties without traditional hassles. Slice
                        simplifies my investment journey, and I couldn't be
                        happier. It's a paradigm shift!
                      </p>
                      <h2 className="comm-head-5 mb5">Alex Popovici</h2>
                      <p className="comm-country">Romania</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        Investing in real estate has always been on my mind,
                        especially in Dubai. With Slice's intuitive app interface,
                        I absolutely love the digital approach it helps me with
                        while letting me pick and choose slices of real estate I
                        want to invest in. Looking forward to growing my portfolio
                        with Slice.
                      </p>
                      <h2 className="comm-head-5 mb5">Clifford de Souza</h2>
                      <p className="comm-country">Dubai</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-text">
                      <div className="rating">
                        <img
                          src={`${REACT_APP_ASSET_URL}/index/rating.svg`}
                          alt=""
                          width="100%"
                          height="100%"
                          loading="lazy"
                        />
                      </div>
                      <p className="comm-body">
                        The Slice app in Dubai is a game-changer for real estate
                        enthusiasts. It's not only user-friendly and cool but also
                        incredibly transparent and educational. It feels like
                        having a mentor in your pocket, providing a fresh
                        perspective on Dubai's real estate scene. I'm thoroughly
                        impressed with the results.
                      </p>
                      <h2 className="comm-head-5 mb5">Zaw Min Htun</h2>
                      <p className="comm-country">Qatar</p>
                    </div>
                  </SwiperSlide>
                </Swiper>

                <div className="client-swiper-btn client-swiper-btn-mob">
                  <div className="swiper-nav swiper-prev clientSwiperPrev">
                    <span className="icon-arrow-left" />
                  </div>
                  <div className="swiper-nav swiper-next clientSwiperNext">
                    <span className="icon-arrow-left" />
                  </div>
                </div>
              </div>
            </div>
            <div className="client-wrapper">
              <div className="box-element">
                <img
                  src={`${REACT_APP_ASSET_URL}/box-elem.svg`}
                  alt=""
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className="stairs-element">
                <img
                  src={`${REACT_APP_ASSET_URL}/stair-elem.svg`}
                  alt=""
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className="star-element">
                <img
                  src={`${REACT_APP_ASSET_URL}/star-elem.svg`}
                  alt=""
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="client-swiper-btn client-swiper-btn-web">
              <div className="swiper-nav swiper-prev clientSwiperPrev">
                <span className="icon-arrow-left" />
              </div>
              <div className="swiper-nav swiper-next clientSwiperNext">
                <span className="icon-arrow-left" />
              </div>
            </div>
            <div className="f-col text-center">
              <Link to="https://webapp.slice.ooo/sign-up" className="butSta" onClick={(e) => {
                gtagEvent("V1SignUp4");
              }}>Sign Up </Link>


            </div>
          </div>
        </section>
        {/* Happy To SLICE END */}
        {/* Partners Starts */}
        <section className="comm-section">
          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2">Our Partners</h3>
            </div>
            <div className="f-row f-4 f-768-3 f-480-2">
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/fab.png`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/Emirates_NBD.webp`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/sumsub.png`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/checkout.svg`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/sovereign.png`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/pkf.JPG`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/crowe.jpg`} alt="" />
                </div>
              </div>
              <div className="f-col">
                <div className="partner-logo">
                  <img src={`${REACT_APP_ASSET_URL}/about/wio.png`} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Partners Ends */}
        <section id="Faqs" className="faqComm pt-0">

          <div className="container">
            <div className="comm-center-head">
              <h3 className="comm-head-2 mb-2">FAQ’s</h3>
              <h4 className="fs-8">Your Key Questions, Answered</h4>
            </div>
            <div className="space-y-4">
              {faqsQus.map((faq, index) => (
                <div
                  key={index}
                  className={`faq-details ${activeIndex === index ? "active" : ""
                    }`}
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="comm-head-4">
                    {faq.question}
                    <span>{activeIndex === index ? "−" : "+"}</span>
                  </h3>
                  {activeIndex === index && (
                    <p className="faq-ans comm-body faq-answer">{faq.answer}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="comm-section  get-slice-box dubaiReal sliceMak">
          <div className="container">
            <div className="comm-center-head ">
              <h3 className="comm-head-2 white">Start Your Journey in Dubai Real Estate</h3>

            </div>


            <div className="f-row f-1 ">
              <div className="f-col mb-4">

                <ul className="d-flex gap-3  my-auto">
                  <li className="fs-8">No joining fee</li>
                  <li className="fs-8">DFSA Regulated</li>
                  <li className="fs-8">Accessible from $100</li>
                </ul>

              </div>
              <div className="f-col text-center">
                <Link href="/" onClick={(e) => {
                  e.preventDefault();
                  callWebengageTrackEvent("Home SLICE Tab clicked");
                  handleScroll(e, "fractiOwners");
                  gtagEvent("L1Get_Started_Footer");
                }} className="butSta btn2">Get Started</Link>


              </div>

            </div>

          </div>
        </section>



      </main>

      <footer className="footer-wrap change-cursor">
        <div className="container change-cursor">
          <div className="footer-box change-cursor">
            <div className="footer-top change-cursor">
              <div className="f-row change-cursor flex-center">
                <div className="w80 w-768-100 footer-logo-wrap change-cursor text-center">
                  <div className="logo footer-logo change-curso ">
                    <img src={`${REACT_APP_ASSET_URL}/slice-logo-white.svg`} alt="Logo" />
                  </div>

                  <p className="footer-txt change-cursor">This platform is incorporated in the Dubai International Financial Centre (DIFC) and regulated by the Dubai Financial Services Authority (DFSA). Investments are made via Special Purpose Vehicles (SPVs). Investing in real estate carries risk. Returns are not guaranteed, and investors may lose part or all of their capital. Past performance is not a reliable indicator of future results.</p>
                </div>

              </div>
            </div>

            <div className="footer-bottom change-cursor text-center d-column">
              <div className="footer-list social-list change-cursor mb-4">
                <ul className=" change-cursor">
                  <li className=" change-cursor">
                    <a href="https://www.instagram.com/slicesuperapp/" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <img src={`${REACT_APP_ASSET_URL}/common/insta.svg`} alt="" width="100%" height="100%" loading="lazy" className="curzr-hover "></img>
                    </a>
                  </li>
                  <li className=" change-cursor">
                    <a href="https://www.facebook.com/SliceSuperApp" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <i className="icon-facebook change-cursor" />
                    </a>
                  </li>
                  <li className=" change-cursor">
                    <a href="https://twitter.com/Slicesuperapp" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <img src={`${REACT_APP_ASSET_URL}/common/twitter.svg`} alt="" width="100%" height="100%" loading="lazy" className="curzr-hover "></img>
                      {/* <i className="icon-twitter change-cursor" /> */}
                    </a>
                  </li>
                  <li className=" change-cursor">
                    <a href="https://www.linkedin.com/company/slice-fintech/" target="_blank" rel="noreferrer" className="curzr-hover change-cursor">
                      <img src={`${REACT_APP_ASSET_URL}/linkedin-logo.svg`} alt="" width="100%" height="100%" loading="lazy" className="curzr-hover linedin-img"></img>
                      {/* <i className="icon-twitter change-cursor" /> */}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="terms-pages change-cursor termsPages">
                <Link to="/faq?data=RiskDisclosures" target="_blank" className="curzr-hover change-cursor" onClick={() => handleLinkClick()}>
                  Key Risk
                </Link>
                <Link to="/terms-condition" target="_blank" className="curzr-hover change-cursor" onClick={() => handleLinkClick()}>
                  Terms & Conditions
                </Link>
                <Link to="/privacy-policy" target="_blank" className="curzr-hover change-cursor" onClick={() => handleLinkClick()}>
                  Privacy Policy
                </Link>
              </div>
              <p className="footer-txt change-cursor w100 ">{(new Date().getFullYear())} Slice. All rights reserved.</p>

            </div>
          </div>
        </div>
      </footer>
      {/* Popup 1 */}
      {showPopup1 && (
        <div className="popupShow">
          <div className="popupShRow">
            {/* <a
              href="javascript:void(0)"
              className="close"
              onClick={handleClose}
            >
              x
            </a> */}
            <h2 className="fs-2">
              Discover How Dubai Property Creates Real Wealth
            </h2>
            <p className="fs-5">
              Unlock your free expert guide explaining how Dubai property has
              historically offered strong yields and capital appreciation,
              supported by investor-friendly regulations.
            </p>
            <button className="butYes but2" onClick={handleYesClick}>
              Yes, I Want the Free Guide!
            </button>
            <button className="butNo" onClick={handleClose}>
              No, I’ll Stay Curious for Now
            </button>
          </div>
        </div>
      )}

      {/* Popup 2 */}
      {showPopup2 && (
        <div className="popupShow">
          <div className="popupShRow ">
            <a
              href="javascript:void(0)"
              className="close"
              onClick={handleClose}
            >   x   </a>
            <h2 className="fs-4">Fill out the form to instantly download Slice’s exclusive investor guide.</h2>
            <div className="card">
              <form onSubmit={handleSubmitPopup} className="formBox">
                <div className="mb-4">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="firstNamePopup"
                    placeholder="First Name"
                    value={formDataPopup.firstNamePopup}
                    onChange={handleChangePopup}
                    className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                  />
                  {popuperrors.firstNamePopup && (
                    <p className="text-red-500 text-sm">{popuperrors.firstNamePopup}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastNamePopup"
                    placeholder="Last Name"
                    value={formDataPopup.lastNamePopup}
                    onChange={handleChangePopup}
                    className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                  />
                  {popuperrors.lastNamePopup && (
                    <p className="text-red-500 text-sm">{popuperrors.lastNamePopup}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="emailPopup"
                    placeholder="Email Address"
                    value={formDataPopup.emailPopup}
                    onChange={handleChangePopup}
                    className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                  />
                  {popuperrors.emailPopup && (
                    <p className="text-red-500 text-sm">{popuperrors.emailPopup}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label>Mobiles</label>
                  <input
                    type="text"
                    name="mobilePopup"
                    placeholder="Mobile Number (optional)"
                    value={formDataPopup.mobilePopup}
                    onChange={handleChangePopup}
                    className="p-3 rounded bg-gray-800 border border-gray-700 text-white"
                  />
                  {popuperrors.mobilePopup && (
                    <p className="text-red-500 text-sm">{popuperrors.mobilePopup}</p>
                  )}
                </div>

                <div className="mb-4">
                  <button className="but2 butDownl">Download Free Guide Now</button>
                </div>
                <div className="labelLock">
                  <label>Your information is secure. We never share your data.</label>
                </div>
              </form>




            </div>

          </div>
        </div>
      )}


      {!isMobile && (
        // <div className="curzr">
        //   <div className="curzr-dot"></div>
        // </div>
        <AnimatedCursor
          innerSize={0}
          outerSize={25}
          innerScale={1}
          outerScale={1.7}
          outerAlpha={0}
          trailingSpeed={1}
          // hasBlendMode={true}
          // innerStyle={{
          //   border: "2px solid #f00",
          // }}
          outerStyle={{
            border: "2px solid rgba(67, 37, 245, 1)",
            background: "rgba(67, 37, 245, 0.5)",
            // border: "2px solid rgba(46, 255, 215, 1)",
            // background: "rgba(46, 255, 215, 0.15)",
            // border: "2px solid rgba(86, 252, 46, 1)",
            // background: "rgba(86, 252, 46, 0.15)",
            mixBlendMode: "difference",
          }}
        />
      )}
    </>
  );
};

export default LPv2;
